/*
* config.js
*
* Description: config.js
*
* This file is part of: "http://apps.sundair.com/", "Sundair-2019"
* Copyright 2018,2019,2020,2021 Sundair GmbH
* Contact:  http://www.sundair.com/
* @author Learek <michael.broeker@sundair.com>
*
*/
/*******************************************************************************
* Config: ENVIRONMENT
*
*/
export let CONF_ENVIRONMENT = "DEV"; // DEV or PROD


/*******************************************************************************
* Config: 3D SECURE INFORMATIONS
*
*/
export const CONF_3DSECURE_ORIGIN = CONF_ENVIRONMENT === "DEV" ? "https://test-directbooking.flyair41.de" : "https://directbooking.flyair41.de"; // https://test-booking2019-2.sundair.com, https://test-directbooking.flyair41.de


/*******************************************************************************
* Config: FLAG::ALWAYSLOGIN
*
*/
export const CONF_FLAG_ALWAYSLOGIN = "true";


/*******************************************************************************
* Config: LIST::ALLOWED CARRIER
*
*/
export const CONF_LIST_ALLOWEDCARRIER = [
    { carrier: 'LBT', key: '9dbbcd28ea408e39894490f83fc81ace' },
    { carrier: 'BUC', key: '1a28cdcd124e01d13d77616110a33ad9' },
    { carrier: 'TWI', key: '2687971a10221273f96b6111ca16e750' },
    { carrier: 'SUN', key: '741caaf2b268e09816bde78cc177807d' },
    { carrier: 'FBR', key: 'c8322b2b7664d84b645714840103650a' },
    { carrier: 'VIM', key: '7f2935de69a1a75eb9a4c63f2f234228' },
];


/*******************************************************************************
* Config: DIRECTBOOKING::RENDER (DB => DIRECT BOOKING)
*
*/
export const CONF_FLAG_FLIGHTBOOKING_ISINDIRECTBOOKING = "true";


/*******************************************************************************
* Config: VERSION/REVISION NUMBER
*
*/
export const CONF_VERSION_NUMBER = "v0.4X";
export const CONF_REVISIONS_NUMBER = "r.2639, 1407261";
